import React, { useRef, useState } from 'lib/react';
import UserMenuPopper from './UserMenuPopper.component';
import UserProfileButton from './UserProfileButton.component';

/**
 * Component that shows a monogram and the name of the user
 */
function UserProfile() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const avatarRef = useRef();

  /**
   * Opens the context menu
   */
  const handleUserProfileButtonClick = () => {
    setAnchorEl(avatarRef.current);
    setIsMenuOpen((isOpen) => !isOpen);
  };

  /**
   * Closes the context menu
   */
  const handleMenuClickAway = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <UserProfileButton
        handleClick={handleUserProfileButtonClick}
        isMenuOpen={isMenuOpen}
        ref={avatarRef}
      />
      <UserMenuPopper
        handleMenuClickAway={handleMenuClickAway}
        anchorEl={anchorEl}
        open={isMenuOpen}
      />
    </>
  );
}

export default UserProfile;
